import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import { useLazyQuery } from '@apollo/client'
import { GET_WAGON_WHEEL_DATA } from '@graphql/wagonWheel/wagonWheel.query'
import { pageLoading } from '@shared/libs/allLoader'
import NoData from '@shared/components/noData'
import PlayerFilter from '../wagonWheel/wagonWheelChart/playerFilter'
import SpiderChart from './spiderChart'

function SpiderStats({ matchDetail, inningData }) {
  const { aInning, oTeamScoreA, oTeamScoreB } = matchDetail || {}
  const teamAId = aInning?.[0]?.iBattingTeamId
  const teamA = teamAId === oTeamScoreA?.oTeam?._id ? oTeamScoreA?.oTeam : oTeamScoreB?.oTeam
  const teamB = teamA?._id === oTeamScoreA?.oTeam?._id ? oTeamScoreB?.oTeam : oTeamScoreA?.oTeam

  const [currentTeamId, setCurrentTeamId] = useState(teamA?._id)
  const [zoneData, setZoneData] = useState([])
  const [runs, setRuns] = useState()
  const [playerData, setPlayerData] = useState(inningData?.find(i => i?.iBattingTeamId === teamA?._id))
  const [isData, setIsData] = useState(false)
  const tabs = [teamA, teamB]

  const labels = ['Fine Leg', 'Square Leg', 'Mid Wicket', 'Long On', 'Long Off', 'Covers', 'Point', 'Third Man']

  function displayData(data) {
    const t = labels?.map(label => {
      const l = data?.find(z => z.zone === label)?.runsScored
      return l
    })
    return t
  }

  useEffect(() => {
    getWagonWheelData({
      variables: {
        input: {
          iMatchId: matchDetail?._id,
          nInningNumber: 1
        }
      }
    })
  }, [])

  // ? INPUT { !MATCH_ID , INNING_NUMBER, BATTERS, BOWLERS}
  const [getWagonWheelData, { loading }] = useLazyQuery(GET_WAGON_WHEEL_DATA, {
    onCompleted: d => {
      const data = d?.getWagonsData || {}
      if (!runs?.total && runs?.total !== 0) {
        setIsData(!!data?.isZone)
        handleZoneData(data)
      } else {
        handleZoneData(data)
      }
    }
  })

  // !Handle Zone Data
  function handleZoneData(d) {
    const data = d?.zones
    const t = displayData(data)
    setZoneData(t)
    const r = { offSide: d?.runs?.offSide, onSide: d?.runs?.onSide, total: d?.runs?.total }
    setRuns(r)
  }

  // !TEAM CHANGE
  function handleTeam(id) {
    const inningNumber = id === teamA?._id ? 1 : id === teamB?._id ? 2 : null
    if (inningNumber !== null) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber
          }
        }
      })
    }
    setCurrentTeamId(id)
    const t = inningData?.find(i => i?.iBattingTeamId === id)
    setPlayerData(t)
  }

  // !Handle Player Data
  function handlePlayersData(batter, bowler) {
    const inningNumber =
      currentTeamId === teamA?._id ? (batter.length === 0 ? 0 : 1) : currentTeamId === teamB?._id ? (batter.length === 0 ? 0 : 2) : null
    if (batter?.length === 0 || inningNumber === 0) {
      setZoneData(Array(8).fill(0))
      setRuns({ onSide: 0, offSide: 0, total: 0 })
    }
    if (inningNumber !== null && inningNumber !== 0) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber,
            iBatterIds: batter,
            iBowlerId: bowler
          }
        }
      })
    }
  }

  return (
    <>
      {!runs?.total && runs?.total !== 0 && loading ? (
        pageLoading()
      ) : isData ? (
        <>
          <div className={`common-box p-0 pt-2 ${styles.box}`}>
            <div className={`d-flex gap-2 ${styles.tabsContainer} `}>
              {tabs?.map((t, i) => {
                return (
                  <div key={i} className={`${styles.tab} ${currentTeamId === t?._id && styles.active}`} onClick={() => handleTeam(t?._id)}>
                    <div>{t?.sTitle}</div>
                  </div>
                )
              })}
            </div>

            <div className={`${styles.runsMobile} d-flex d-md-none py-2`}>
              <div className="d-flex gap-1 align-items-baseline">
                <span>Off Side: </span>
                <p>
                  {runs?.offSide}
                  <span className="mx-1">runs</span>
                </p>
              </div>
              <span className={styles.divider} />
              <div className="d-flex gap-1 align-items-baseline">
                <span>On Side: </span>
                <p>
                  {runs?.onSide}
                  <span className="mx-1">runs</span>
                </p>
              </div>
            </div>

            <div className={styles.mainContainer}>
              <div className={styles.runs}>
                <h6>Off Side:</h6>
                <p className="text-3xl">
                  {runs?.offSide}
                  <span className="mx-1 text-lg">runs</span>
                </p>
              </div>

              {/* WAGON WHEEL */}
              {loading ? (
                <div style={{ minWidth: '400px', minHeight: '400px' }} className="d-flex justify-content-center">
                  {pageLoading()}
                </div>
              ) : (
                <div className={`d-flex mb-4 justify-content-center ${styles.spiderContainer}`}>
                {zoneData && <SpiderChart labels={labels} displayData={zoneData} />}
                </div>
              )}

              <div className={styles.runs}>
                <h6>On Side:</h6>
                <p>
                  {runs?.onSide}
                  <span className="mx-1">runs</span>
                </p>
              </div>
            </div>
          </div>
          <PlayerFilter
            handlePlayersData={handlePlayersData}
            matchDetail={matchDetail}
            playerData={playerData}
            currentTeamId={currentTeamId}
          />
        </>
      ) : (
        <NoData />
      )}
    </>
  )
}

SpiderStats.propTypes = {
  matchDetail: PropTypes.object,
  inningData: PropTypes.array
}

export default SpiderStats
